/* eslint-disable import/prefer-default-export */
const defaultFilter = className => typeof className === 'string';

const normalizeClassList = (classList) => {
  const isArray = classList instanceof Array;

  if(typeof classList === 'object' && !isArray){
    const defaultClasses = normalizeClassList(classList.default);
    const customClasses = normalizeClassList(classList.custom);
    const requiredClasses = normalizeClassList(classList.required);

    return [
      ...defaultClasses,
      ...customClasses,
      ...requiredClasses
    ]
  }

  if(typeof classList === 'undefined'){
    return [''];
  }

  return classList instanceof Array ? classList : [classList];
}

export const createClassList = (classList, filter) => {
  const modifiedClassList = normalizeClassList(classList);
  
  const classFilter = typeof filter !== 'function' ? defaultFilter : filter;
  return modifiedClassList
    .filter(classFilter)
    .join(' ')
    .trim();
}